import React from "react";
import MainAppGenericModal from "../../../../atoms/Modals/GenericModal";

import styles from "./MainApp.organisms.Category.Modals.ErrorCategoryModal.module.scss";
import i18n from "i18n";

export class ErrorCategoryModal extends React.Component {

  render() {
    const {
      open,
      handleClose,
      category
    } = this.props;

    const content = (<div className={styles["error-category-modal-wrapper"]}>
      <div className={styles["error-category-modal-text"]}><span className={styles["error-category-modal-text-bold"]}>{i18n.t("cant.delete")}</span> <br></br> {i18n.t("error.category.associated.products", {category: category ? category.name : ''})}</div>
      <div className={styles["error-category-modal-buttons"]}>
        <div className={styles["error-category-modal-button"]} onClick={handleClose} data-automation-id="confirm">{i18n.t("understood").toUpperCase()}</div>
      </div>
    </div>)
    return (
      <div className={styles["error-category-modal-container"]}>
          <MainAppGenericModal open={open} content={content} handleClose={handleClose}></MainAppGenericModal>
      </div>
    );
  }
}

ErrorCategoryModal.propTypes = {
};

export default ErrorCategoryModal;
